import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Sparkles } from "lucide-react";

export const LoadingState = () => {
  return (
    <div className="space-y-4 animate-fade-in-up">
      {/* Loading indicator */}
      <div className="flex items-center justify-center gap-3 py-4">
        <Sparkles className="h-5 w-5 text-primary animate-pulse" />
        <p className="text-sm text-muted-foreground animate-pulse">
          Analyzing your post...
        </p>
      </div>

      {/* Score skeleton */}
      <Card className="border border-border shadow-md">
        <CardContent className="p-8">
          <div className="flex flex-col items-center gap-6">
            {/* Circular score skeleton */}
            <Skeleton className="w-32 h-32 sm:w-40 sm:h-40 rounded-full" />
            {/* Verdict skeleton */}
            <Skeleton className="h-8 w-36 rounded-full" />
            {/* Label skeleton */}
            <Skeleton className="h-4 w-48" />
          </div>
        </CardContent>
      </Card>

      {/* Breakdown skeleton */}
      <Card className="border border-border shadow-md">
        <CardContent className="p-6 space-y-4">
          <Skeleton className="h-6 w-40 mb-4" />
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="space-y-2">
              <div className="flex justify-between">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-12" />
              </div>
              <Skeleton className="h-2.5 w-full rounded-full" />
            </div>
          ))}
        </CardContent>
      </Card>

      {/* Feedback skeleton */}
      <Card className="border border-border shadow-md">
        <CardContent className="p-6 space-y-4">
          <Skeleton className="h-6 w-32 mb-4" />
          <div className="space-y-3">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-4/6" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoadingState;
